var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 29.3333L5.33301 29.3332C3.86634 29.3332 2.66634 28.2082 2.66634 26.8332L2.66634 11.8332C2.66634 10.4582 3.86634 9.33325 5.33301 9.33325L26.6663 9.33325C28.133 9.33325 29.333 10.4583 29.333 11.8333L29.333 26.8333C29.333 28.2083 28.133 29.3333 26.6663 29.3333Z",
    fill: "url(#paint0_linear_31182_154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.333 6.66667C12.5966 6.66667 11.9997 7.26362 11.9997 8V9.33333H9.33301V8C9.33301 5.79086 11.1239 4 13.333 4H18.6663C20.8755 4 22.6663 5.79086 22.6663 8V9.33333H19.9997V8C19.9997 7.26362 19.4027 6.66667 18.6663 6.66667H13.333Z",
    fill: "#91919C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0003 14.6667H14.0003V18.0001H10.667L10.667 22.0001H14.0003V25.3334H18.0003V22.0001H21.3337V18.0001H18.0003V14.6667Z",
    fill: "#F7F7FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31182_154",
    x1: 18.5544,
    y1: 22.8645,
    x2: 28.6663,
    y2: 9.20521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#91919D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAid);
export default __webpack_public_path__ + "static/media/Aid.d63e978db6d9ce2fef19f434b844cef0.svg";
export { ForwardRef as ReactComponent };